import striptags from "striptags";

export default {
  computed: {
    titleMetaPrefix() {
      return "";
    },
    site() {
      if (this.$env.SITE === 'chiche') return 'chiche_by_makesense'
      else return this.__("events that makesense");
    },
    metaTitle() {
      return (
        this.titleMetaPrefix +
        this.event.title[this.event.lang] +
        " · Inscription · " +
        this.$dayjs(this.event.date).format('DD/MM/YYYY')
      );
    },
    metaImg() {
      if (this.event.cover && this.event.cover[this.event.lang]) return this.event.cover[this.event.lang].url;
      else return this.$env.logoUrl;
    },
    metaDescription() {
      return striptags(
        this.event.description &&
          this.event.description[this.event.lang] &&
          this.event.description[this.event.lang].substring(0, 150)
      );
    },
    head() {
      let organizer;
      if (this.event.user && this.event.user.length) {
        organizer = this.event.user[0].displayname || (this.event.user[0].firstName + ' ' + this.event.user[0].lastName);
      }
      else if (this.event.source && this.event.source.user) {
        organizer = this.event.source.user;
      }
      const structuredData = [
        {
          "@context": "http://schema.org",
          "@type": "Organization",
          "name": "makesense",
          "url": "france.makesense.org",
          "logo": this.$env.logoUrl,
          "address": '11 rue Biscornet, 75012 Paris',
          "contactPoint": {
            "@type": "ContactPoint",
            "email": "chiche@makesense.org",
            "contactType": "Service client"
          }
        },
        {
          "@context": "http://schema.org",
          "@type": "Event",
          about: this.event.topic && this.event.topic.name ? this.event.topic.name[this.event.lang] : '',
          additionalType: this.event.type && this.event.type.name ? this.event.type.name[this.event.lang] : undefined,
          description: this.metaDescription,
          duration: "",
          endDate: this.$dayjs(this.event.endDate).format('YYYY-MM-DD'),
          eventAttendanceMode: this.event.visio
            ? "https://schema.org/OnlineEventAttendanceMode"
            : "https://schema.org/OfflineEventAttendanceMode",
          image: this.event.cover && this.event.cover[this.event.lang] ? this.event.cover[this.event.lang].url : undefined,
          inLanguage: this.event.lang,
          isAccessibleForFree: true,
          location: {
            address: this.event.visio ? undefined : this.event.address ? this.event.address[this.event.lang].formattedAddress : undefined
          },
          maximumAttendeeCapacity: this.event.maxAttendees,
          name: this.event.title[this.event.lang],
          organizer: organizer,
          startDate: this.$dayjs(this.event.date).format('YYYY-MM-DD'),
        }
      ];
      return {
        title: this.metaTitle,
        meta: [
          {
            hid: "description",
            name: "description",
            content: this.metaDescription
          },
          { hid: "og:title", name: "og:title", content: this.metaTitle },
          { hid: "og:image", name: "og:image", content: this.metaImg },
          { hid: "image", name: 'image', property: "og:image", content: this.metaImg },
          {
            hid: "og:description",
            name: "og:description",
            content: this.metaDescription
          },
          {
            hid: "twitter:title",
            name: "twitter:title",
            content: this.metaTitle
          },
          { hid: "twitter:image", name: "twitter:image", content: this.metaImg },
          {
            hid: "twitter:description",
            name: "twitter:description",
            content: this.metaDescription
          },
          { hid: "og:image:width", name: "og:image:width", content: 1280 },
          { hid: "og:image:height", name: "og:image:height", content: 800 }
        ],
        link: [
          {
            rel: 'canonical',
            href: this.$env.eventsUrl + this.$route.path,
          },
        ],
        script: [
          {
            type: "application/ld+json",
            children: structuredData
          }
        ]
      };
    },
  },
};
